export type AddPanelModal = {
  open: boolean,
	orientation: ORIENTATION
};

export enum ORIENTATION {
	LANDSCAPE = 'LANDSCAPE',
	PORTRAIT = 'PORTRAIT',
	DEFAULT = 'DEFAULT',
}